import '../../resources/css/settings/ModalRoleDetail.scss';
import React, { Component } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { openModal, closeModal, popupModalConfirm, openModalAlert } from '../../actions/index';
import RoleForm from './RoleForm';
import { doRemoveRole } from '../../actions/settings/index'

class ModalRoleDetail extends Component {

    handleDelete(){
        const { accountData, roleDetail, popupModalConfirm, authToken, selectRole, closeModal, openModalAlert, doRemoveRole } = this.props;
        if (!accountData.find(e => e.roleId === roleDetail.seq)) {
            popupModalConfirm('Delete', 'icon-ico-failed', 'Confirm to remove?', 300, () => doRemoveRole(authToken, selectRole.seq), null, false);
            closeModal(null);
        } else {
            openModalAlert("You cannot delete role if one or more account is assigned to this role.");
        }
    }
    
    render() {
        const { closeModal, modalStatus, modalMessage, selectRole, openModal } = this.props;
        let show = modalStatus === 'settingsRole';
        let isAdd = modalMessage === 'add';
        let classModal = 'modal-settings-role-detail';
        let renderContent;
        if (show && (selectRole || isAdd)) {
            let headerTitle = isAdd ? "Add new role" : selectRole.name;

            renderContent = (
                <Modal
                    show={show}
                    dialogClassName={ classModal }
                    centered
                    onHide={() => closeModal(null)}
                >
                    <Modal.Body>
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6}>
                                    <span className='header-title'>{ headerTitle }</span>
                                </Col>
                                <Col sm={6} className='area-close-btn'>
                                    { modalMessage === 'view' ? <><span className='icon-btn-edit-white-n' onClick={() => {closeModal(null); openModal("settingsRole", 'edit', null, null)}}></span>
                                     {/* <span className='icon-btn-delete-white-n' onClick={() => { popupModalConfirm('Delete', 'icon-ico-failed', 'Confirm to remove?', 300, () => doRemoveRole(authToken, selectRole.seq), null, false); closeModal(null);}}></span> */}
                                     <span className='icon-btn-delete-white-n' onClick={() => this.handleDelete() }></span>
                                     </>: '' }
                                    <span className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            <RoleForm></RoleForm>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='area-settings-role-detail'>
                {renderContent}                
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        modalStatus: state.commonReducers.modalStatus,
        modalMessage: state.commonReducers.modalMessage,
        selectRole: state.settingsReducers.selectRole,
        authToken: state.loginReducers.authToken,
        accountData: state.settingsReducers.accountData,
        roleDetail: state.settingsReducers.roleDetail,
    }
}

export default connect(
    mapStateToProps,
    { openModal, closeModal, doRemoveRole, popupModalConfirm, openModalAlert }
)(ModalRoleDetail)